import React from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import CardSeparator from "../CardSeparator/CardSeparator";
import styled from "styled-components";

const popoverMaxLength = 3;

const StyledWrapper = styled.div`
  .badge-secondary {
    color: #fff;
    background-color: #6c757d;
  }
`;

const StyledSpan = styled.span`
  cursor: pointer;
`;

const StyledPopover = styled(Popover)`
  .card-header:first-child {
    border-radius: calc(0.6rem - 1px) calc(0.6rem - 1px) 0 0;
  }
  .card-header {
    padding: 2rem 2rem 0.5rem 2rem;
    margin-bottom: 0;
    border-bottom: 0px solid rgba(0, 0, 0, 0.125);
    font-weight: 700;
  }
  .card-body {
    padding: 0.5rem 2rem 2rem 2rem;
  }
`;

export const TablePopover = (props) => {
  const { description, data } = props;

  if (data) {
    if (data.length > popoverMaxLength) {
      const remaining = data.length - popoverMaxLength;
      return (
        <StyledWrapper data-testid="table-popover">
          {data.map((child, index) => {
            if (index < popoverMaxLength) {
              return (
                <h5 key={`icon-entry-${index}`}>
                  <span className={`badge badge-secondary`}>{child.name}</span>
                </h5>
              );
            }
            return null;
          })}
          <h5 key={`icon-entry-popover`}>
            <OverlayTrigger
              placement="right"
              overlay={
                <StyledPopover>
                  <div className="card-header">
                    {description}
                    <CardSeparator style="-green" />
                  </div>
                  <StyledWrapper className="card-body">
                    {data.map((child, index) => {
                      if (index >= popoverMaxLength) {
                        return (
                          <h5 key={`icon-entry-${index + 1}`}>
                            <span className={`badge badge-secondary`}>
                              {child.name}
                            </span>
                          </h5>
                        );
                      }
                      return null;
                    })}
                  </StyledWrapper>
                </StyledPopover>
              }
            >
              <StyledSpan className="badge badge-secondary">
                {`+`}
                {remaining}
              </StyledSpan>
            </OverlayTrigger>
          </h5>
        </StyledWrapper>
      );
    } else {
      return (
        <StyledWrapper data-testid="table-popover">
          {data.map((child, index) => {
            return (
              <h5 key={`icon-entry-${index}`}>
                <span className={`badge badge-secondary`}>{child.name}</span>
              </h5>
            );
          })}
        </StyledWrapper>
      );
    }
  } else {
    return null;
  }
};
